import { Type } from 'class-transformer';
import { FormBuilderSectionModel } from './form-builder-section-model';

export class FormBuilderSeedModel {

    public formId: string;
    public versionId: string;
    public title: string;
    public code: string;
    public type: string;

    // This Type is used to inform `plainToClass` which Class to cast the `sections` property
    @Type(() => FormBuilderSectionModel)
    public sections: FormBuilderSectionModel[];
    seed: FormBuilderSectionModel;
}
